import breakpoints from '../theme/breakpoints';
import { ComponentsOverrides } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';

const styleOverrides: ComponentsOverrides['MuiStepper'] = {
  root: ({ theme }) => ({
    gap: (theme as Theme).spacing(1),
    [`@media only screen and (min-width: ${breakpoints.md}px)`]: {
      gap: (theme as Theme).spacing(3),
    },
  }),
};

export default styleOverrides;
